import { useState, useEffect } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const fallbackFaq = [
  {
    id: "1",
    question: "Was kostet die Online-Pflegeberatung?",
    answer: "Die Pflegeberatung nach § 37.3 SGB XI ist für Sie komplett kostenfrei. Die Kosten werden vollständig von Ihrer Pflegekasse übernommen."
  },
  {
    id: "2",
    question: "Wer hat Anspruch auf Pflegeberatung?",
    answer: "Jede Person mit einem anerkannten Pflegegrad (1-5) hat Anspruch auf regelmäßige Pflegeberatung. Auch pflegende Angehörige können die Beratung in Anspruch nehmen."
  },
  {
    id: "3",
    question: "Wie funktioniert die Video-Beratung?",
    answer: "Nach der Terminbuchung erhalten Sie einen Video-Link per E-Mail. Zum vereinbarten Zeitpunkt klicken Sie einfach auf den Link – Sie benötigen nur ein Gerät mit Kamera und Internetverbindung (Smartphone, Tablet oder Computer)."
  },
  {
    id: "4",
    question: "Was ist der Entlastungsbetrag von 131€?",
    answer: "Pflegebedürftige mit Pflegegrad 1-5 haben Anspruch auf monatlich 131€ für Entlastungsleistungen. Wir beraten Sie, wie Sie diesen Betrag optimal nutzen können."
  },
  {
    id: "5",
    question: "Ich bin nicht technikaffin – kann ich trotzdem teilnehmen?",
    answer: "Absolut! Unsere Video-Beratung ist sehr einfach zu bedienen. Sie klicken lediglich auf einen Link. Gerne helfen wir Ihnen auch telefonisch bei der Einrichtung."
  },
  {
    id: "6",
    question: "Wie oft kann ich die Beratung nutzen?",
    answer: "Bei Pflegegrad 2-5 ist eine Beratung alle 6 Monate verpflichtend, bei Pflegegrad 1 freiwillig. Sie können die Beratung aber auch häufiger in Anspruch nehmen."
  },
  {
    id: "7",
    question: "Gilt das Angebot nur für NRW?",
    answer: "Ja, unser Service ist speziell auf Nordrhein-Westfalen ausgerichtet. So können wir Sie optimal zu regionalen Angeboten und Ansprechpartnern beraten."
  },
];

export default function FAQ() {
  const [faqData, setFaqData] = useState(fallbackFaq);

  useEffect(() => {
    const fetchFaq = async () => {
      try {
        const res = await axios.get(`${API}/faq`);
        if (res.data && res.data.length > 0) {
          setFaqData(res.data);
        }
      } catch {
        // Use fallback
      }
    };
    fetchFaq();
  }, []);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 lg:py-28 bg-[#F8FAFC]"
      aria-label="Häufige Fragen zur Online-Pflegeberatung"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block text-sm font-semibold text-cyan-700 bg-cyan-50 px-4 py-1.5 rounded-full mb-4">
            Häufige Fragen
          </span>
          <h2 className="font-['Manrope'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 mb-4">
            Ihre Fragen, unsere Antworten
          </h2>
          <p className="text-base sm:text-lg text-slate-500">
            Finden Sie schnell Antworten auf die häufigsten Fragen zur Online-Pflegeberatung.
          </p>
        </div>

        {/* Accordion */}
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {faqData.map((item) => (
            <AccordionItem
              key={item.id}
              value={item.id}
              className="bg-white border border-slate-200/60 rounded-xl px-6 shadow-sm data-[state=open]:shadow-md transition-shadow"
              data-testid={`faq-item-${item.id}`}
            >
              <AccordionTrigger className="text-base sm:text-lg font-semibold text-slate-800 hover:text-cyan-700 hover:no-underline py-5">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-base text-slate-600 leading-relaxed pb-5">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
